.ClaimsTooltip {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.ClaimsTooltip_tooltip {
  white-space: pre-line;
}
